import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const ProductMiniView = ({ product }) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [pulsing, setPulsing] = useState(true);

  const navigate = useNavigate();

  const imageLoaded = () => {
    setImageLoading(false);
    setTimeout(() => setPulsing(false), 600);
  };
  return (
    <Product>
      <motion.div
        initial={{ opacity: 0, scale: 0.2 }}
        whileInView={{ opacity: 1, scale: 1 }}
        className="container"
      >
        <motion.img
          initial={{ x: -200, opacity: 0, scale: 0.8 }}
          whileInView={{ x: 0, opacity: 1, scale: 1, rotate: 90 }}
          transition={{ duration: 1 }}
          className="product-thumbnail"
          onLoad={imageLoaded}
          width="100%"
          src={product.image}
          onClick={() => {
            navigate("/products/1");
          }}
        />
        <p className="product-name">{product.productName}</p>
        <p className="product-price">{product.sellingPrice}</p>
        {/* <button
          className="btn-view-product"
          onClick={() => {
            navigate("/products/1");
          }}
        >
          View
        </button> */}
      </motion.div>
    </Product>
  );
};

export default ProductMiniView;

const Product = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;

  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }

  .product-thumbnail {
    display: flex;
    width: 80%;
    height: auto;
    object-fit: contain;
    margin: 20px auto;
    border-radius: 5px;
    /* border: 1px solid black; */
  }
  .product-price {
    margin: 0;
    text-align: center;
  }
  .product-name {
    margin: 0;
    text-align: center;
    font-weight: 900;
  }

  .btn-view-product {
    display: flex;
    width: 100%;
    background-color: #a3705f;
    color: #f2e6e2;
    border: none;
    border-radius: 3px;
    height: 40px;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    cursor: pointer;
  }
`;
